import { capitalize } from "@core/utils";
import type { ItemCategory } from "@src/types";
import type { Product } from "./types";

// item.categories vem como caminhos da árvore: ['/NEW COLLECTION/MALHA/', '/NEW COLLECTION/']
const SALE_CATEGORIES = /outlet|bazar|sale/i;
const AVOID_CATEGORIES = /^(outlet|bazar|sale|cole(ç|c)(ã|a)o)$/i;

const getLevels = (path: string): string[] => path.split("/").filter(Boolean);
const isProductCrumb = (path?: string): boolean => /\/p\/?$/.test(path ?? "");

// PDC entrega item.categories; na PDP a árvore só existe no breadcrumbList
const getCategoryPaths = (item: Product): string[] => {
  if (item && "categories" in item && item.categories?.length) return item.categories;

  const names = [...(item?.breadcrumbList?.itemListElement ?? [])]
    .sort((a, b) => (a?.position ?? 0) - (b?.position ?? 0))
    .filter((crumb) => crumb?.name && !isProductCrumb(crumb?.item))
    .map((crumb) => crumb.name.trim());

  return names.length ? [`/${names.join("/")}/`] : [];
};

export const getItemCategory = (item: Product): ItemCategory => {
  const categories = getCategoryPaths(item);
  if (!categories.length) return "Coleção";

  const match = categories.join(" ").match(SALE_CATEGORIES)?.[0].toLowerCase();
  return (match as ItemCategory) ?? "Coleção";
};

export const getItemCategory2 = (item: Product): string => {
  const categories = getCategoryPaths(item);
  for (const path of [...categories].reverse()) {
    const deepest = getLevels(path)
      .reverse()
      .find((level) => !AVOID_CATEGORIES.test(level.trim()));

    if (deepest) return capitalize(deepest.trim()) ?? "";
  }

  return "";
};

export const isInStock = (availability?: string): boolean => /InStock/i.test(availability ?? "");
